import { isMatch, isValid, parse } from "date-fns";

export const DATE_SEGMENTS = {
  MONTH: "mm",
  DAY: "dd",
  YEAR: "yyyy",
} as const;

export type DateSegments = (typeof DATE_SEGMENTS)[keyof typeof DATE_SEGMENTS];

export const removeNonDigits = (input: string) => input.replace(/\D/g, "");

export const applyPad = (value: string, segment: DateSegments) => {
  const digits = removeNonDigits(value);

  if (!digits) return "";

  switch (segment) {
    case DATE_SEGMENTS.MONTH:
      return digits.padStart(2, "0").slice(0, 2);
    case DATE_SEGMENTS.DAY:
      return digits.padStart(2, "0").slice(0, 2);
    case DATE_SEGMENTS.YEAR:
      return digits.slice(0, 4);
  }
};

// need this because new Date generates a valid date even with invalid data
// e.g. Feb 30 becomes March 2 and validation does not flag it
export const parseStrictDate = (value: string): Date | null => {
  if (!isMatch(value, "MM/dd/yyyy")) return null;

  const date = parse(value, "MM/dd/yyyy", new Date());

  return isValid(date) ? date : null;
};

export const combineDate = (mm: string, dd: string, yyyy: string) => {
  if (mm.length === 2 && dd.length === 2 && yyyy.length === 4) {
    return `${mm}/${dd}/${yyyy}`;
  }
  return "";
};
